module.exports = __webpack_public_path__ + "media/brands-banner/CardkiveGrayscaleLogo-19c8b621.svg";